function InvoiceModel(data) {
    this.tableData = this.createTableData(data);
    this.pagination = this.createPaginationData(data);
}

InvoiceModel.prototype = Object.assign(InvoiceModel.prototype, {
    createTableData(tableData) {
        if (
            tableData &&
            tableData.invoiceViewList &&
            tableData.invoiceViewList.length > 0
        ) {
            return tableData.invoiceViewList.map(row => this.createRow(row));
        }
        return [];
    },
    createPaginationData(data) {
        if (data) {
            const { totalElements } = data;
            return {
                hasNextPage: false,
                hasPreviousPage: false,
                pageNumber: 0,
                pageSize: 10,
                sortingCriteria: '',
                totalNumberOfPages: 0,
                totalNumberOfRecords: totalElements,
            };
        }
        return {};
    },
    createRow(row) {
        const {
            merchantId,
            merchantName,
            invoicePeriod,
            invoiceDate,
            invoiceNumber,
            grossAmount,
            totalFee,
            totalGST,
            totalValue,
            invoiceURL,
            settlementType,
            paymentStatus,
        } = row;
        return {
            merchantId,
            merchantName,
            invoicePeriod,
            invoiceDate,
            invoiceNumber,
            grossAmount,
            totalFee,
            totalGst: totalGST,
            totalValue,
            invoiceURL,
            settlementType,
            paymentStatus,
        };
    },
});

export default InvoiceModel;
